import { render } from "./underSupervision.vue?vue&type=template&id=75beac00&scoped=true"
import script from "./underSupervision.vue?vue&type=script&lang=js"
export * from "./underSupervision.vue?vue&type=script&lang=js"

import "./underSupervision.vue?vue&type=style&index=0&id=75beac00&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75beac00"]])

export default __exports__